import { useCallback } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useDeleteAccordion = (companyId, selectedYear, setQuarters) => {
    const deleteAccordion = useCallback(async (quarterKey, accordionTimestamp) => {
        const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);

        const docSnapshot = await getDoc(yearDocRef);

        if (!docSnapshot.exists() || !docSnapshot.data()[quarterKey]) return;

        const updatedQuartersArray = docSnapshot.data()[quarterKey].filter(accordion => accordion.timeStamp !== accordionTimestamp);
        
        await updateDoc(yearDocRef, {
            [quarterKey]: updatedQuartersArray
        });

        setQuarters(prev => {
            const updatedQuarters = { ...prev };
            updatedQuarters[quarterKey] = updatedQuartersArray;
            return updatedQuarters;
        });
    }, [companyId, selectedYear, setQuarters]);

    return deleteAccordion;
};

export default useDeleteAccordion;
